import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styled, { keyframes } from 'styled-components'
import { sendWebViewMsg } from 'utils/bridge'

export default function AnimatedWindow({ windowOn, children, zIndex, setWindowOn }) {
  const windowRef = useRef(null)
  const [transformStat, setTransformStat] = useState('off')
  let animationOn = () => {
    windowRef.current.classList.add('slide-on')
    windowRef.current.classList.remove('slide-off')
  }
  let animationOff = () => {
    windowRef.current.classList.add('slide-off')
    windowRef.current.classList.remove('slide-on')
  }

  const location = useLocation()

  useEffect(() => {
    if (windowOn === true) {
      animationOn()

      window.history.pushState(null, '')
      sendWebViewMsg({
        action: 'RES_URL_HISTORY_CHANGE',
        data: {
          action: 'PUSH',
          location,
        },
      })
      const popEventHandler = () => {
        if (setWindowOn) {
          setWindowOn(false)
        }
      }

      window.addEventListener('popstate', popEventHandler)

      return () => {
        window.removeEventListener('popstate', popEventHandler)
      }
    } else {
      animationOff()
    }
  }, [windowOn])

  return (
    <AnimationWindowSection windowOn={windowOn} zIndex={zIndex} ref={windowRef}>
      {children}
    </AnimationWindowSection>
  )
}

export const AnimationWindowSection = styled.div`
  position: fixed;
  top: 0;
  right: ${(props) => {
    return props['windowOn'] === true ? '0' : '-100%'
  }};
  bottom: 0;
  left: ${(props) => {
    return props['windowOn'] === true ? '0' : '100%'
  }};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow-y: hidden;
  margin: auto;
  z-index: ${(props) => {
    return props['zIndex'] ? props['zIndex'] : '500'
  }};
  transition: all 0.3s cubic-bezier(0, 1, 0, 1);
`
